import requests, { setToken } from "./httpServices";
import { showErrorAlert } from "./AlertService";
const PaymentServices = {
  payNow: async (paymentData) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      console.log(paymentData);
      const response = await requests.post("/payments/pay", paymentData);
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  getPaymentHistory: async () => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const response = await requests.get("/payments/order-history");
      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  }
};

export default PaymentServices;
